import React from 'react';
import {Info} from "lucide-react";

export type DecryptionTooltipProps =
    | {'data-tooltip-left': string}
    | {'data-tooltip-right': string};

interface MessageTextContentProps {
    textNode: React.ReactNode;
    /** Kept for callers; sent and received text share the ink colour on the DS bubbles. */
    isOwnMessage: boolean;
    isDecryptionErrorMessage: boolean;
    decryptionErrorTooltipProps: DecryptionTooltipProps;
}

export const MessageTextContent: React.FC<MessageTextContentProps> = ({
    textNode,
    isDecryptionErrorMessage,
    decryptionErrorTooltipProps,
}) => {
    return (
        <div className={`whitespace-pre-wrap message-content flex items-center gap-2 text-ink`}>
            <div className="min-w-0 flex-1 break-words">
                {textNode}
            </div>
            {isDecryptionErrorMessage && (
                <button
                    type="button"
                    className="inline-flex items-center justify-center shrink-0"
                    data-decryption-tooltip="true"
                    {...decryptionErrorTooltipProps}
                    aria-label="Decryption details"
                >
                    <Info className="p-1.5" size={32}/>
                </button>
            )}
        </div>
    );
};
